var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 account-container",attrs:{"fluid":"","fill-height":""}},[_c('div',{staticClass:"not-found-page"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("Page not found")]),_c('v-btn',{attrs:{"link":"","to":{ name: 'CourseEvents' }}},[_vm._v("Go to home page")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }